/**
 * Question Set content validator
 * Validates question set data for required fields
 */

import type { ContentValidator, ValidationResult } from '@ai-content-hub/content-core';
import type { QuestionSetData } from './schema';

export const questionSetValidator: ContentValidator<QuestionSetData> = {
    validate(data: QuestionSetData): ValidationResult {
        const errors: ValidationResult['errors'] = [];

        if (!data?.title?.trim()) {
            errors.push({ field: 'title', message: 'Title is required.' });
        }

        const items = data?.items ?? [];
        if (items.length === 0) {
            errors.push({ field: 'items', message: 'Phải chứa ít nhất 01 câu hỏi con bên trong tập hợp.' });
        }

        return { isValid: errors.length === 0, errors };
    },
};
